// This is used to clean up the product titles for strings included in SEO work in react helmet (in new/view-all/util/index).
// When some of the product name discrepencies are changed this function will no longer be needed, and in the 'description' field
// it can be replaced with the short version of the product name. The react helmet was origionally implemented to grab a piece of the
// pageTitle which were in general shorter, so when the product titles are standerdized, this can be changed to productTitle (or remain as pageTitle).

export function cleanCardName(cardname) {
  let cardNameReturn = cardname;

  if (cardname.includes('American Express')) {
    cardNameReturn = cardNameReturn.replace('American Express', '');
  }
  return cardNameReturn.replace(/\s+/g, ' ').trim();
}

export function cleanCardNameCard(cardname) {
  let cardNameReturn = cardname;

  if (cardname?.includes('Card')) {
    cardNameReturn = cardNameReturn?.replace('Card', '');
  }
  return cardNameReturn?.replace(/\s+/g, ' ').trim();
}
